<template>
  <div>
    <v-subheader>
      <v-icon class="mr-2">mdi-truck</v-icon>
      Frete padrão
    </v-subheader>
    <v-divider/>
    <v-row class="mt-3">
      <v-col cols="4">
        <px-select-enum class="required"
                        label="Tipo de frete"
                        :error="$v.catalogo.frete.tipoFrete.$error"
                        @blur="$v.catalogo.frete.tipoFrete.$touch()"
                        v-model="catalogo.frete.tipoFrete"
                        @change="resetTaxaEntrega"
                        :items="tiposFretes"/>
      </v-col>
      <v-col cols="12" sm="4">
        <px-input-money
          ref="taxaEntrega"
          class="required"
          label="Taxa de entrega"
          :error="$v.catalogo.frete.valorTaxaEntrega.$error"
          @blur="$v.catalogo.frete.valorTaxaEntrega.$touch()"
          v-model="catalogo.frete.valorTaxaEntrega"
          :disabled="isFob"/>
      </v-col>
      <v-col cols="12" sm="4">
        <px-input-number :label="labelPrazo"
                         required
                         class="required"
                         :error="$v.catalogo.frete.prazoEmbarque.$error"
                         @blur="$v.catalogo.frete.prazoEmbarque.$touch()"
                         v-model="catalogo.frete.prazoEmbarque"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-switch
          hide-details
          v-model="catalogo.frete.ofertaFreteGratis"
          label="Oferta frete grátis"
          @change="onChangeFrete"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="6">
        <px-input-money
          ref="taxaMinimaEntrega"
          autocomplete="off"
          label="Valor mínimo para frete grátis"
          :disabled="!catalogo.frete.ofertaFreteGratis"
          v-model="catalogo.frete.taxaMinimaEntrega"/>
      </v-col>
    </v-row>

    <v-subheader class="mt-5">
      <v-icon class="mr-2">mdi-map-marker</v-icon>
      Fretes por CEP
    </v-subheader>
    <v-divider/>
    <px-cadastro-catalogo-frete-ceps ref="cadastroFreteCep" @add="onAddFrete"/>
    <px-cadastro-catalogo-frete-cep-list
      v-if="catalogo.ceps && catalogo.ceps.length"
      :itens-frete="catalogo.ceps"
      @remove="onRemoveItem"
      @update="onUpdateItem"/>

    <v-row class="mt-5">
      <v-col cols="12">
        <v-btn color="primary"
               :loading="loading"
               @click="emitReady">
          Próximo
        </v-btn>
        <v-btn class="ml-2" text @click="emitPrevious">Voltar</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import { TipoFrete } from 'px-business-components';
import CadastroCatalogoFreteCeps from './CadastroCatalogoFreteCeps.vue';
import CadastroCatalogoFreteCepList from './CadastroCatalogoFreteCepList.vue';

export default {
  mixins: [validationMixin],
  props: {
    catalogo: Object,
    loading: Boolean,
  },
  data() {
    return {
      tiposFretes: TipoFrete.values,
    };
  },
  computed: {
    isFob() {
      return this.catalogo.frete.tipoFrete === TipoFrete.keys.FOB.key;
    },
    labelPrazo() {
      if (this.isFob) {
        return 'Prazo de embarque (Dias úteis)';
      }
      return 'Prazo de entrega (Dias úteis)';
    },
  },
  methods: {
    emitReady() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('ready');
    },
    emitPrevious() {
      this.$emit('previous');
    },
    resetTaxaEntrega() {
      this.$refs.taxaEntrega.$el.getElementsByTagName('input')[0].value = 0;
      this.catalogo.valorTaxaEntrega = 0;
    },
    onAddFrete(frete) {
      if (!this.catalogo.ceps) {
        Vue.set(this.catalogo, 'fretes', []);
      }
      this.catalogo.ceps.push(frete);
    },
    onRemoveItem(index) {
      this.catalogo.ceps.splice(index, 1);
    },
    onUpdateItem(index) {
      const item = this.catalogo.ceps[index];
      this.catalogo.ceps.splice(index, 1);
      this.$refs.cadastroFreteCep.buildEditing(item);
    },
    onChangeFrete() {
      if (!this.catalogo.frete.ofertaFreteGratis) {
        this.$refs.taxaMinimaEntrega.$el.getElementsByTagName('input')[0].value = 0;
      }
    },
  },
  created() {
  },
  validations: {
    catalogo: {
      frete: {
        tipoFrete: {
          required,
        },
        valorTaxaEntrega: {
          required,
        },
        prazoEmbarque: {
          required,
        },
      },
    },
  },
  components: {
    pxCadastroCatalogoFreteCeps: CadastroCatalogoFreteCeps,
    pxCadastroCatalogoFreteCepList: CadastroCatalogoFreteCepList,
  },
};
</script>
